export default __webpack_public_path__ + "static/media/doc-pagenation-arrow.833f6548.svg";